<template>
  <div>
    <el-button
      class="my-2"
      type="primary"
      @click="newField()"
      ><i class="fas fa-plus mr-1"></i> New Field</el-button
    >

    <el-table
      :data="fieldsWithDefaults"
      style="width: 100%"
    >
      <el-table-column width="80px" label="Order">
        <template slot-scope="scope">
          <div v-if="!scope.row.preDefined">
            <el-tooltip
              placement="top"
              content="Move Up"
              effect="light"
            >
              <el-button
                @click="orderUp(scope.row)"
                :disabled="
                  isFirstNonPreDefined(scope.$index)
                "
                type="text"
                size="small"
                ><i class="fas fa-chevron-up"></i
              ></el-button>
            </el-tooltip>
            <el-tooltip
              placement="top"
              content="Move Down"
              effect="light"
            >
              <el-button
                :disabled="
                  isLastNonPreDefined(scope.$index)
                "
                @click="orderDown(scope.row)"
                type="text"
                size="small"
              >
                <i class="fas fa-chevron-down"></i
              ></el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
      ></el-table-column>
      <el-table-column
        prop="type"
        label="Type"
      ></el-table-column>
      <el-table-column label="Properties/Relations">
        <template slot-scope="scope">
          <div>
            <div
              v-for="(property, index) in scope.row
                .properties"
              :key="index"
            >
              <span>- {{ property }}</span>
            </div>
          </div>
          <div>
            <div
              v-for="(relation, index) in scope.row
                .relation"
              :key="index"
            >
              <span>- {{ relation }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Validations">
        <template slot-scope="scope">
          <div
            v-for="(validation, index) in scope.row
              .validations"
            :key="index"
          >
            <span>- {{ validation }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.preDefined ||
                scope.row.isRelationship
            "
          >
            <el-button
              size="small"
              disabled
              icon="el-icon-lock"
            ></el-button>
          </div>

          <div
            v-if="
              !scope.row.preDefined &&
                !scope.row.isRelationship
            "
          >
            <el-button
              v-if="relationshipEnabled"
              size="small"
              @click="copy(scope.row)"
              ><i class="far fa-copy"></i>
            </el-button>
            <el-button size="small" @click="edit(scope.row)"
              ><i class="far fa-edit"></i>
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="remove(scope.row)"
              ><i class="fas fa-trash"></i
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-field-list',

  computed: {
    ...mapGetters({
      data: 'builder/data',
      entity: 'builder/entityCurrent/current',
      fields: 'builder/fieldCurrent/listForTable',
      scaffold: 'scaffold/current',
      relationshipEnabled: 'builder/relationship/enabled',
    }),

    fieldsWithDefaults() {
      const fields = [...this.fields].sort(
        (a, b) => (a.order || 0) - (b.order || 0),
      );

      const id = {
        id: 'id',
        name: 'id',
        type: 'UUID',
        preDefined: true,
      };

      const updatedAt = {
        id: 'updatedAt',
        name: 'updatedAt',
        type: 'Datetime',
        preDefined: true,
      };

      const createdAt = {
        id: 'createdAt',
        name: 'createdAt',
        type: 'Datetime',
        preDefined: true,
      };

      return [id, ...fields, updatedAt, createdAt].filter(
        Boolean,
      );
    },
  },

  methods: {
    isFirstNonPreDefined(index) {
      if (this.fieldsWithDefaults[index].preDefined) {
        return false;
      }

      if (index === 0) {
        return false;
      }

      return this.fieldsWithDefaults[index - 1].preDefined;
    },

    isLastNonPreDefined(index) {
      if (this.fieldsWithDefaults[index].preDefined) {
        return false;
      }

      if (index === this.fieldsWithDefaults.length - 1) {
        return false;
      }

      return this.fieldsWithDefaults[index + 1].preDefined;
    },

    newField() {
      this.$router.push({
        name: 'field-new',
        params: {
          scaffoldId: this.scaffold.id,
          entityId: this.entity.id,
        },
      });
    },

    edit(field) {
      this.$router.push({
        name: 'field-edit',
        params: {
          scaffoldId: this.scaffold.id,
          entityId: this.entity.id,
          id: field.id,
          reload: true,
        },
      });
    },

    orderUp(field) {
      const { dispatch } = this.$store;
      dispatch('builder/fieldCurrent/orderUp', field);
    },

    orderDown(field) {
      const { dispatch } = this.$store;
      dispatch('builder/fieldCurrent/orderDown', field);
    },

    remove(field) {
      const { getters, dispatch } = this.$store;

      const matches = getters[
        'builder/entityOrFieldReference/search'
      ](this.data, field);

      if (matches) {
        const validationErrorMessage = `The entity is in use at: <br/> ${matches.join(
          '<br/>',
        )}`;
        dispatch(
          'core/validationErrorHtml',
          new Error(validationErrorMessage),
        );
        return;
      }

      dispatch('builder/fieldCurrent/delete', field);
    },

    copy(field) {
      const { dispatch } = this.$store;
      dispatch('builder/fieldCurrent/copy', field);
    },
  },
};
</script>

<style></style>
